import React from 'react';
import Hero from '../../components/Hero/Hero';
import Metadata from '../../components/Metadata/Metadata';
import Section from '../../components/Section/Section';

import { Box } from '@mui/material';

const PageContent: React.FC = () => {
  return (
    <Box>
      <Metadata title="Privacy Policy" description="" />
      <Hero helper="General Genomics" headline="Privacy Policy" />
      <Section className="justification-left">
        <h2 className="action-on-view action-fade-in">
          General Genomics’ terms of service
        </h2>
        <p className="action-on-view action-fade-in">
          Welcome to General Genomics, Inc. (together with its affiliates and
          subsidiaries, “GGI”). These Terms of Service (“Terms”) are legally
          binding upon you in the event that you use any service of GGI’s,
          including this website, and all linked and associated sites, surveys,
          and applications owned by GGI (the “Services”). If you do not consent
          to these Terms, you should immediately cease using any of GGI’s
          Services, including this website. These Terms govern your use and
          access to GGI’s Services regardless if the use or access is in
          connection with a GGI account or not. These Terms may be modified at
          any time and without prior notice to you. Your continued use of the
          Services means that you consent to these Terms as they may be modified
          in the future. GGI reserves the right to refuse to complete any of the
          Services in the event you either violate these Terms or are otherwise
          prohibited from utilizing the Services.
        </p>

        <h2 className="action-on-view action-fade-in">
          No unauthorized, unlawful, or harmful use of site
        </h2>
        <p className="action-on-view action-fade-in">
          The Services are only for your use and you are the only authorized
          person to use it. You may not use any “deep-link,” “page-scrape,”
          “robot,” “spider,” or other automatic device, program, algorithm, or
          methodology, or any similar or equivalent manual process, to access,
          acquire, copy, or monitor any portion of the Services or any content
          of the Services, or in any way reproduce or circumvent the
          navigational structure or presentation of the Services or any content
          thereof, to obtain or attempt to obtain any materials, documents or
          information through any means not purposely made available through the
          Services. GGI reserves all legal rights available to bar any such
          activity.
        </p>
        <p className="action-on-view action-fade-in">
          You may not attempt to gain unauthorized access to any portion or
          feature of the Services, or any other systems or networks connected to
          the Services or to any of the services offered on or through our
          website, by hacking, password “mining,” or any other illegitimate
          means.
        </p>
        <p className="action-on-view action-fade-in">
          You may not probe, scan, or test the vulnerability of our Services,
          including this website or any network connected to the website or
          Services, nor breach the security or authentication measures on our
          website or Services or any network connected to the website or
          Services. You may not reverse look-up, trace, or seek to trace any
          information on any other user of or visitor to our website or
          Services, or any other customer of GGI, including any Curo46 account
          not owned by you, to its source, or exploit the Services or
          information made available or offered by or through the Services, in
          any way where the purpose is to reveal any information, including but
          not limited to personally identifiable information (“PII”), other than
          your own information.
        </p>
        <p className="action-on-view action-fade-in">
          You agree that you will not take any action that imposes an
          unreasonable or disproportionately large load on the infrastructure of
          GGI’s systems or networks, or any systems or networks connected to the
          Services or to GGI.
        </p>

        <p className="action-on-view action-fade-in">
          You agree not to use any device, software, or routine to interfere or
          attempt to interfere with the proper working of the Services or any
          transaction being conducted via the Services, or with any other
          person’s use of the Services.
        </p>

        <p className="action-on-view action-fade-in">
          You may not forge headers or otherwise manipulate identifiers in order
          to disguise the origin of any message or transmittal you send to GGI
          on or through any Services. You may not pretend that you are, or that
          you represent, someone else, or impersonate any other individual or
          entity.
        </p>

        <p className="action-on-view action-fade-in">
          You may not use the Services or any content of the Services for any
          purpose that is unlawful or prohibited by these Terms, or to solicit
          the performance of any illegal activity or other activity which
          infringes the rights of GGI or others.
        </p>

        <h2 className="action-on-view action-fade-in">
          Your account and user permissions
        </h2>
        <p className="action-on-view action-fade-in">
          Certain Services offered may require you to open an account. You are
          entirely responsible for maintaining the confidentiality of the
          information you hold for your account, including your password and for
          any and all activity that occurs under your account as a result of you
          failing to keep this information secure and confidential. You agree to
          notify GGI immediately of any unauthorized use of your account or
          password, or any other breach of security. You may be held liable for
          losses incurred by GGI or any other user of Services due to someone
          else using your information, including password or account as a result
          of you failing to keep your account information secure and
          confidential. You will ensure that all users granted access to your
          account comply with these Terms, or other notices or conditions that
          GGI may, in its sole discretion, provide at any time without prior
          notice, and any confidentiality or other agreement you enter into with
          GGI. If you, and if applicable, make changes to your settings or user
          permissions within the Services, it may take some time for our system
          to process the change and you acknowledge that those changes may not
          take effect immediately.
        </p>

        <h2 className="action-on-view action-fade-in">
          Links to external sites
        </h2>
        <p className="action-on-view action-fade-in">
          The Services may contain links to other independent third-party
          websites (“Linked Sites”). These Linked Sites are provided solely as a
          convenience to our visitors. Such Linked Sites are not under GGI’s
          control, and GGI is not responsible for and does not endorse the
          content of such Linked Sites, including any information or materials
          contained on such Linked Sites. You will need to make your own
          independent judgment regarding your interaction with these Linked
          Sites.
        </p>

        <h2 className="action-on-view action-fade-in">
          Information provided by you
        </h2>
        <p className="action-on-view action-fade-in">
          GGI retains all rights permitted by law and, as determined in GGI’s
          sole discretion, may use any information you post or submit through
          the Services for any lawful use to GGI’s benefit. For other
          information and materials you post or otherwise provide via the
          Services (a “Submission”), you grant GGI, a non-exclusive,
          royalty-free, perpetual, irrevocable license to (1) use, copy,
          distribute, transmit, make available, publicly display, publicly
          perform, reproduce, edit, adapt, modify, translate, reformat and
          create derivative works of your Submission, each in connection with
          the Services and any program or project, and (2) sublicense these
          rights, to the maximum extent permitted by applicable law. GGI will
          not pay you for your Submission and may remove your Submission at any
          time. For each Submission, you represent that you have all rights
          necessary for you to grant us the rights provided in this section and
          that such Submission is lawfully permissible.
        </p>

        <p className="action-on-view action-fade-in">
          You acknowledge that GGI will communicate with you primarily via email
          or by posting notices on the Services. You agree that all agreements,
          notices, disclosures, and any other communications that we provide to
          you electronically satisfy any legal requirements that such
          communications be in writing. To the maximum extent permitted by
          applicable law, GGI, may monitor any electronic communications and/or
          activity you make via the Services and may disclose such information
          in the event it has a good faith reason to believe it is necessary for
          purposes of ensuring your compliance with these Terms, protecting the
          rights, property, and interests of GGI or any third party, or for any
          lawful purpose GGI may desire.
        </p>

        <h2 className="action-on-view action-fade-in">Content</h2>
        <p className="action-on-view action-fade-in">
          All text, graphics, user interfaces, visual interfaces, photographs,
          trademarks, logos, sounds, music, artwork, and computer code
          (collectively, “Content”), including but not limited to the design,
          structure, selection, coordination, expression, “look and feel,” and
          arrangement of such Content, contained within the Services, is owned,
          controlled, or licensed by or to GGI, and is protected by trade dress,
          copyright, patent, and trademark laws, and various other intellectual
          property rights and unfair competition laws. Certain images on this
          website are provided by the Defense Visual Information Service (DVIS).
          The appearance of U.S. Department of Defense (DoD) visual information
          does not imply or constitute DoD endorsement. GGI does not claim
          ownership of these images.
        </p>

        <p className="action-on-view action-fade-in">
          Except as expressly provided in these Terms, no part of the Services
          and no Content may be copied, reproduced, republished, uploaded,
          posted, publicly displayed, encoded, translated, transmitted or
          distributed in any way (including “mirroring”) to any other computer,
          server, Web site or other medium for publication or distribution or
          for any commercial enterprise, without GGI’s express prior written
          consent.
        </p>

        <p className="action-on-view action-fade-in">
          You may use information on GGI’s products and Services (such as data
          sheets, knowledge base articles, and similar materials) purposely made
          available by GGI for downloading via the Services, provided that you
          (1) not remove any proprietary notice language in all copies of such
          documents, (2) use such information only for your personal,
          non-commercial informational purpose, and do not copy or post such
          information on any networked computer or broadcast it in any media,
          (3) make no modifications to any such information, and (4) do not make
          any additional representations or warranties relating to such
          documents.
        </p>

        <h2 className="action-on-view action-fade-in">
          Disclaimers of warranties
        </h2>
        <p className="action-on-view action-fade-in">
          GGI PROVIDES THE SERVICES “AS IS,” “WITH ALL FAULTS,” AND “AS
          AVAILABLE.” GGI DOES NOT PROMISE OR REPRESENT THAT THE SERVICES OR ANY
          CONTENT, PARTICULAR SERVICE, OR FEATURE WILL BE ERROR-FREE OR
          UNINTERRUPTED, OR THAT ANY DEFECTS WILL BE CORRECTED, OR THAT YOUR USE
          OF THE SERVICES WILL PROVIDE SPECIFIC RESULTS OR THAT ANY MEDICAL
          ISSUES MAY CORRECTLY BE DIAGNOSED. GGI DOES NOT PROVIDE MEDICAL
          ADVICE. YOU EXPRESSLY AGREE THAT USE OF THE SERVICES AND CONTENT ARE
          AT YOUR SOLE RISK. YOU EXPRESSELY AGREE THAT ALL CONTENT VIA THE
          SERVICES DOES NOT REPRESENT OR CONVEY IN ANY WAY THAT ANY APPLICATIONS
          LINKED OR CONTAINED WITHIN THE SERVICES WILL CURE OR TREAT ANY
          ILLNESS, DISEASE, OR OTHERWISE, AND YOUR PERMITTED USE AUTHORISED BY
          GGI, SUBJECT TO THESE TERMS, DOES NOT, IN ANY WAY, WARRANT IN ANY
          CAPACITY THE RESULTS OF ANY SERVICE. TO THE FULLEST EXTENT PERMITTED
          BY APPLICABLE LAW, GGI MAKES NO REPRESENTATIONS, WARRANTIES, OR
          CONDITIONS, EXPRESS OR IMPLIED, AS TO THE OPERATION OF THE SERVICES OR
          THE INFORMATION, CONTENT, AND MATERIALS INCLUDED VIA THE SERVICES, OR
          OTHERWISE, AND DISCLAIMS ANY AND ALL WARRANTIES OR CONDITIONS,
          EXPRESS, STATUTORY, AND IMPLIED, INCLUDING WITHOUT LIMITATION (1)
          WARRANTIES OR CONDITIONS OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
          PURPOSE, WORKMANLIKE EFFORT, ACCURACY, TITLE, QUIET ENJOYMENT, NO
          ENCUMBRANCES, NO LIENS AND NON-INFRINGEMENT, (2) WARRANTIES OR
          CONDITIONS ARISING THROUGH COURSE OF DEALING OR USAGE OF TRADE, AND
          (3) WARRANTIES OR CONDITIONS THAT ACCESS TO OR USE OF THE SERVICES
          WILL BE UNINTERRUPTED OR ERROR-FREE. GGI DOES NOT WARRANT THAT ANY
          APPLICATION, SERVICES, ITS SERVERS, OR EMAILS SENT ARE ERROR-FREE,
          WILL OPERATE WITHOUT INTERRUPTIONS OR DOWNTIME, OR ARE FREE OF VIRUSES
          OR OTHER HARMFUL COMPONENTS. YOU ASSUME TOTAL RESPONSIBILITY FOR YOUR
          USE OF THE SERVICES AND ANY LINKED SITES. YOUR SOLE REMEDY AGAINST GGI
          FOR DISSATISFACTION WITH THE SERVICES OR ANY CONTENT IS TO STOP USING
          THE SERVICES OR ANY SUCH CONTENT.
        </p>

        <p className="action-on-view action-fade-in">
          The above disclaimer applies to any damages, liability, or injuries
          caused by any failure of performance, error, omission, interruption,
          deletion, defect, delay in operation or transmission, computer virus,
          communication line failure, theft or destruction of or unauthorized
          access to, alteration of, or use, whether for breach of contract,
          tort, negligence or any other cause of action.
        </p>

        <p className="action-on-view action-fade-in">
          GGI reserves the right to do any of the following, at any time,
          without notice: (1) to modify, suspend, or terminate operation of or
          access to the Services, or any portion of the Services, for any
          reason; (2) to modify or change the Services, or any portion of the
          Services, and any applicable policies or terms; and (3) to interrupt
          the operation of the Services, or any portion of the Services, as
          necessary to perform routine or non-routine maintenance, error
          correction, or other changes.
        </p>

        <h2 className="action-on-view action-fade-in">
          Limitation of liability
        </h2>
        <p className="action-on-view action-fade-in">
          IN NO EVENT WILL GGI BE LIABLE FOR ANY DAMAGES, INCLUDING WITHOUT
          LIMITATION ANY DIRECT, INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL,
          OR PUNITIVE DAMAGES, INCLUDING LOST PROFITS, EVEN IF GGI HAS BEEN
          ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, ARISING OUT OF, BASED ON,
          OR RESULTING FROM THESE TERMS OR YOUR USE OF THE SERVICES. THESE
          LIMITATIONS AND EXCLUSIONS APPLY WITHOUT REGARD TO WHETHER THE DAMAGES
          ARISE FROM (1) BREACH OF CONTRACT, (2) BREACH OF WARRANTY, (3)
          NEGLIGENCE, OR (4) ANY OTHER CAUSE OF ACTION, TO THE EXTENT SUCH
          EXCLUSION AND LIMITATIONS ARE NOT PROHIBITED BY APPLICABLE LAW.
          WITHOUT LIMITING THE GENERALITY OF THE PRECEDING SECTIONS, YOU
          ACKNOWLEDGE AND AGREE THAT GGI IS NOT RESPONSIBLE OR LIABLE FOR (1)
          ANY CONTENT; (2) ANY THIRD PARTY CONDUCT, TRANSMISSIONS OR DATA; (3)
          ANY VIRUSES OR OTHER DISABLING FEATURES THAT AFFECT YOUR ACCESS TO OR
          USE OF THE SERVICES; (4) ANY INCOMPATIBILITY BETWEEN THE APPLICATIONS,
          SERVICES, SOFTWARE, AND HARDWARE; OR (5) ANY DELAYS OR FAILURES YOU
          MAY EXPERIENCE IN INITIATING, CONDUCTING, OR COMPLETING ANY
          TRANSMISSIONS OR TRANSACTIONS IN CONNECTION WITH THE SERVICES. THE
          LIMITATIONS, EXCLUSIONS, AND DISCLAIMERS IN THESE TERMS APPLY TO THE
          MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW.
        </p>

        <p className="action-on-view action-fade-in">
          If, notwithstanding the other provisions of these Terms, GGI is found
          to be liable to you for any damage or loss which arises out of or is
          in any way connected with your use of the Services or any Content,
          GGI’s liability shall in no event exceed the greater of (1) the total
          of any subscription or similar fees with respect to any Service or
          feature of or in the Services paid in the six months prior to the date
          of the initial claim made against GGI (but not including the purchase
          price for any GGI program), or (2) US$100.00. Some jurisdictions do
          not allow limitations of liability, so the foregoing limitation may
          not apply to you.
        </p>

        <h2 className="action-on-view action-fade-in">Indemnification</h2>
        <p className="action-on-view action-fade-in">
          You agree to release, indemnify, defend, and hold harmless GGI and its
          affiliates, parent companies, subsidiaries, and their respective
          officers, directors, shareholders, predecessors, successors in
          interest, employees, and agents against any demands, claims, losses,
          damages, settlements, costs, expenses or other liabilities (including,
          without limitation, attorneys’ fees), made against GGI by your or any
          third party due to or arising out of or in connection with your use of
          the Services (together, “Claims”).You agree to use counsel reasonably
          satisfactory to GGI to defend each Claim. If at any time GGI
          reasonably determines that any Claim might adversely affect GGI, GGI
          may take control of the defense at our expense. You may not consent to
          the entry of any judgment or enter into any settlement without GGI’s
          prior written consent, which may be withheld for any reason.
        </p>

        <h2 className="action-on-view action-fade-in">Supplemental</h2>
        <p className="action-on-view action-fade-in">
          These Terms may be modified or supplemented by other terms and
          conditions contained within specific contractual documents. To the
          degree these Term conflict with any specific contractual terms between
          you and GGI, the specific contractual terms shall apply.
        </p>

        <h2 className="action-on-view action-fade-in">Termination</h2>
        <p className="action-on-view action-fade-in">
          GGI may disclose any information we have about you (including your
          identity) if we determine that such disclosure is necessary in
          connection with any investigation or complaint regarding your use of
          the Services, or to identify, contact, or bring legal action against
          someone who may be causing injury to or interfering with (either
          intentionally or unintentionally) GGI’s rights or property, or the
          rights or property of visitors to or users of the Services. GGI
          reserves the right at all times to disclose any information that GGI
          deems necessary to comply with any applicable law, regulation, legal
          process, or governmental request. GGI also may disclose your
          information when GGI determines that applicable law requires or
          permits such disclosure, including exchanging information with other
          companies and organizations for fraud protection purposes.
        </p>

        <p className="action-on-view action-fade-in">
          You acknowledge and agree that GGI may preserve any transmittal or
          communication by you with GGI through the Services and may also
          disclose such data if required to do so by law or GGI determines that
          such preservation or disclosure is reasonably necessary to (1) comply
          with legal process, (2) enforce these Terms, (3) respond to claims
          that any such data violates the rights of others, or (4) protect the
          rights, property, or personal safety of GGI, its employees, users of
          or visitors to the Services, and the public.
        </p>

        <p className="action-on-view action-fade-in">
          You agree that GGI may, in its sole discretion and without prior
          notice, terminate your access to the Services and/or block your future
          access to the Services if we determine that you have violated these
          Terms or other agreements or guidelines which may be associated with
          your use of the Services. You also agree that any violation by you of
          these Terms will constitute an unlawful and unfair business practice,
          and will cause irreparable harm to GGI, for which monetary damages
          would be inadequate, and you consent to GGI obtaining any injunctive
          or equitable relief that GGI deems necessary or appropriate in such
          circumstances. These remedies are in addition to any other remedies
          GGI may have at law or in equity.
        </p>

        <p className="action-on-view action-fade-in">
          You agree that GGI may, in its sole discretion and without prior
          notice, terminate your access to the Services, due to (1) requests by
          law enforcement or other government agencies, (2) a request by you
          (self-initiated account deletions), (3) discontinuance or material
          modification of the Services, or (4) unexpected technical issues or
          problems.
        </p>

        <p className="action-on-view action-fade-in">
          If GGI does take any legal action against you as a result of your
          violation of these Terms, GGI will be entitled to recover from you,
          and you agree to pay, all reasonable attorneys’ fees and costs of such
          action, in addition to any other relief granted to GGI. You agree that
          GGI will not be liable to you or to any third party for termination of
          your access to the Services as a result of any violation of these
          Terms.
        </p>

        <h2 className="action-on-view action-fade-in">
          Choice of law and venue
        </h2>
        <p className="action-on-view action-fade-in">
          The laws of the State of Oklahoma govern these Terms and the Services
          and any dispute or claims for enforcement, breach or violation of
          duties, or rights under these Terms or by virtue of the Services,
          without reference to conflict of laws principles. You hereby
          irrevocably consent to the exclusive jurisdiction and venue of the
          District Court of Oklahoma County in all disputes arising out of or
          relating to the use of the Services or Content.
        </p>

        <h2 className="action-on-view action-fade-in">
          Use of your information for research or internal purposes
        </h2>
        <p className="action-on-view action-fade-in">
          In order to improve the Services and develop other Services, GGI may
          utilize information obtained from you via the Services for its
          internal business purposes such as product development and/or for
          research purposes, including any other use authorized by you. These
          activities may include, among other things, improving our Services
          and/or offering new products or Services to you or performing quality
          control activities; conducting data analysis that may lead to and/or
          include commercialization with a third party.
        </p>

        <h2 className="action-on-view action-fade-in">Privacy Policy</h2>
        <p className="action-on-view action-fade-in">
          Data privacy laws and regulations are still in their developmental
          stage within the United States and other jurisdictions. Accordingly,
          this Privacy Policy is intended to ensure compliance with the various
          data protection laws and regulations when using the Services; however,
          to the extent any law or regulation differs from the terms set forth
          herein, GGI will comply with the jurisdictional requirements of that
          variant state or country if applicable. This Privacy Policy applies to
          your use of the Services and all other websites, pages, features, or
          content owned or controlled by GGI if applicable law so requires.
        </p>

        <h3 className="action-on-view action-fade-in">
          A. Information Collected by GGI.
        </h3>

        <p className="action-on-view action-fade-in">
          In order to perform the Services, we may collect personally
          identifiable information (“PII”). Depending upon the jurisdiction
          within which you reside or operate, PII may have differing
          definitions. Nonetheless, PII is information that can be utilized to
          reasonably identify an individual, and may include, but is not
          necessarily limited to, information about an individual such as name,
          user ID, password, address, date of birth, or genetic information;
          provided, publicly available information, de-identified data, and/or
          aggregate data may not be considered PII. To the maximum extent
          possible, GGI de-identifies and aggregates data when PII is being
          utilized for purposes other than rendering Services to you, and often
          even when rendering Services to you. De-Identified Information is
          information that has been stripped of PII, so that an individual
          cannot be reasonably identified, and aggregate information is
          information regarding a group of people and cannot be reasonably
          linked to a particular individual.
        </p>

        <h3 className="action-on-view action-fade-in">
          B. How GGI Collects Information.
        </h3>

        <p className="action-on-view action-fade-in">
          We collect information provided by you when you access any of GGI’s
          Services. We may also collect information from third-party providers.
          Further, GGI may utilize either the information collected directly
          from you or third-party providers to infer certain characteristics
          about individuals. To the extent an applicable data privacy law so
          requires, GGI will afford to you those rights, typically including,
          but not necessarily limited to, the right to know who GGI shares your
          PII with, the right to opt-out of such sharing, the right to correct
          inaccurate PII, the right to delete your PII, the right to access your
          PII and/or obtain a copy of the same, the right to limit the use and
          sharing of your PII, and the right to have an authorized agent act on
          your behalf. To exercise any such applicable rights, please contact:
          Jeffrey Rothchild, jeffrey@curo46.com, to exercise any applicable
          right, GGI will require identity verification.
        </p>

        <h3 className="action-on-view action-fade-in">
          C. How GGI Uses Your Information.
        </h3>

        <p className="action-on-view action-fade-in">
          GGI does not sell PII. Subject to applicable law, GGI uses your
          information for internal business purposes such as: Performing
          contractual obligations between you and GGI, improving or developing
          new Services, internal security, internal auditing and verification,
          debugging, contacting you regarding the Services, investigate and/or
          enforce any violation of the Terms or applicable law, conduct
          research, and comply with legal requirements. GGI only retains PII as
          long as necessary to provide the Services or to comply with legal
          obligations or for legitimate lawful business purposes.
        </p>

        <h3 className="action-on-view action-fade-in">
          D. Who GGI Shares Information with.
        </h3>

        <p className="action-on-view action-fade-in">
          Subject to applicable law, we share information with our service
          providers who help us provide the Services. Such service providers
          enter into agreements with GGI to protect the confidentiality and
          security of data, including PII. You may direct GGI to share your
          information with anyone you so choose. PII may also be shared
          internally with subsidiaries and affiliates of GGI when necessary and
          permitted by law. GGI will not otherwise share or sell any PII and
          will not disclose PII to any governmental agency, absent compliance
          with appropriate legal process. GGI may also utilize PII to enforce
          GGI’s Terms or to protect the rights of GGI, its affiliates and
          employees, and the public. GGI abides by any legally binding specific
          requests regarding the sharing, storing, or deletion of PII unless the
          same interferes with a legitimate business right of GGI.
        </p>

        <h3 className="action-on-view action-fade-in">
          E. How GGI Protects your Information.
        </h3>

        <p className="action-on-view action-fade-in">
          GGI utilizes physical, technical, and administrative measures to
          prevent unauthorized access to the Services and relevant data,
          including PII. Nonetheless, protection of your passwords and login
          credentials are your responsibility, and GGI disclaims any and all
          responsibility for breach of the Services or PII via your failure to
          protect your own information.
        </p>

        <h3 className="action-on-view action-fade-in">F. EU Compliance.</h3>

        <p className="action-on-view action-fade-in">
          If you are a resident of the EU or participating state in the EU
          General Data Protection Regulation (“GDPR”) we process PII based upon
          consent, legal obligations, and/or legitimate interests to protect
          GGI’s rights and the rights of third-parties or other customers of
          GGI. You may have the right to access, delete, correct, or withdraw
          your consent, or have your data ported to you. You can verify the
          ability to exercise these rights by contacting: Jeffrey Rothchild,
          jeffrey@curo46.com.
        </p>

        <h3 className="action-on-view action-fade-in">
          G. Updates to Privacy Terms and Conditions.
        </h3>

        <p className="action-on-view action-fade-in">
          Any revisions or updates to these Privacy Policies will be posted on
          our website, and your continued use of the Services is to be
          considered consent to any revisions or updates to these Privacy
          Policies.
        </p>

        <h3 className="action-on-view action-fade-in">
          COMPLETE AGREEMENT AND SEVERABILITY
        </h3>

        <p className="action-on-view action-fade-in">
          These Terms, including the Privacy Policy, contain the sole agreement
          between the parties pertaining to the purchase, use, and support of
          the Services. There are no other representations or agreements except
          as contained herein, unless in writing and signed by you and GGI. This
          Agreement may only be modified by written instrument signed and
          executed by you and GGI. Further, to the extent any term or provision
          herein is considered illegal or unenforceable, the remaining
          provisions contained herein that are not subject to such illegality or
          unenforceability shall remain in full force and effect; provided
          further, to the extent any term or provision contained herein is
          illegal or unenforceable, but is subject to modification by a court to
          bring the same into legal or enforceable compliance, you and GGI agree
          that a court may exercise such power to revise the term or provision
          to bring it within lawful or enforceable compliance.
        </p>
      </Section>
    </Box>
  );
};

export default PageContent;
